import type { ExtraType } from "../../../../common-deprecated/types/CommonTypes";
import { useCarConfigSelector } from "../redux/store";
import { find } from "../../../../common-deprecated/utils";

const useAphHomeCharger = (homeCharger: ExtraType): { isSelected: boolean } => {
    const basketHomeChargers = useCarConfigSelector((state) => state.basket.extras);

    const basketHomeCharger = find(homeCharger.id, basketHomeChargers);

    return { isSelected: !!basketHomeCharger };
};

export default useAphHomeCharger;
